/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-array-index-key */
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import {
  Box,
  Checkbox,
  Drawer,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { Dispatch, SetStateAction, useState } from 'react';
import { useSelector } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import { layoutPrivateStyle } from '../../styles/layout/private-routes';

import { useQueryGetNotification, useQueryReadAllNotification } from '../../api/dashboard';
import { NotificationList } from '../../types/dashboard';
import { selectAuthUser } from '../../store/auth/selector';

type NotificationProps = {
  showNotification: boolean;
  setShowNotification: Dispatch<SetStateAction<boolean>>;
  badgeInvisible: boolean;
  setBadgeInvisible: Dispatch<SetStateAction<boolean>>;
};

export function Notification({ showNotification, setShowNotification, badgeInvisible, setBadgeInvisible }: NotificationProps) {
  const profile = useSelector(selectAuthUser);
  const queryClient = useQueryClient()

  const [notificationList, setnotificationList] = useState<NotificationList[]>([]);
  const [readAll, setReadAll] = useState(false);

  const getNotification = useQueryGetNotification({
    query: {
      userId: profile.userId,
      take: 100,
      page: 0
    },
    options: {
      onSuccess: (res) => {
        const hasReadAll = res.data?.notifications?.every(notification => notification.isRead === true);
        setBadgeInvisible(hasReadAll)
        setnotificationList(res.data?.notifications)
        
      },
      onError: () => {
      }
    },
  });

  const readAllNotification = useQueryReadAllNotification({
    query: {
      userId: profile.userId
    },
    options: {
      enabled: readAll,
      onSuccess: (res) => {
        setReadAll(false)
        queryClient.invalidateQueries({ queryKey: ['getNotification'] });
      },
      onError: () => {
      }
    },
  });

  return (
    <Drawer
      anchor="right"
      open={showNotification}
      onClose={() => setShowNotification(false)}
      PaperProps={{
        style: {
          boxShadow: '0px 0px 5px #33333333',
        },
      }}
      style={{ width: '0', zIndex: 5 }}
      hideBackdrop
      disableScrollLock
    >
      <Stack
        component="section"
        direction="column"
        marginTop="55px"
        width="358px"
        height="100%"
        sx={{
          background: '',
          position: 'relative',
          overflow: 'clip',
          boxShadow: '0px 0px 5px #33333333',
          '-webkit-box-shadow': '0px 0px 5px #33333333',
          '-moz-box-shadow': '0px 0px 5px #33333333',
        }}
      >
        <Stack
          sx={{
            position: 'relative',
            zIndex: 1,
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" padding="15px">
            <Typography fontSize="16px" fontWeight="bold">
              Notification
            </Typography>
            <IconButton
              sx={{ height: '16px', width: '16px', cursor: 'pointer' }}
              onClick={() => {
                if (badgeInvisible === false) {
                  setReadAll(true)
                }
                setShowNotification(false)
              }}
            >
              <CloseIcon sx={{ color: '#999999' }} />
            </IconButton>
          </Stack>
          <Stack padding="10px" direction="row" justifyContent="end">
            <Stack sx={layoutPrivateStyle.notificationReadStack}>
              <RemoveRedEyeIcon sx={layoutPrivateStyle.notificationReadIcon} />
              <Typography 
                fontSize="14px" 
                color="#028ED5" 
                onClick={() => badgeInvisible === false ? setReadAll(true) : ""}
              >
                Mark All Read
              </Typography>
            </Stack>
            <Stack sx={{ ...layoutPrivateStyle.notificationReadStack, display: 'none' }}>
              <DeleteIcon sx={layoutPrivateStyle.notificationReadIcon} />
              <Typography fontSize="14px" color="#028ED5">
                Dismiss All
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        {notificationList.length > 0 ? (
          <Stack sx={layoutPrivateStyle.notificationListContainer}>
            {notificationList.map((list) => (
              <Stack
                key={list.notificationId}
                sx={{
                  ...layoutPrivateStyle.notificationListCard,
                  background: list.isRead ? '#FFFFFF' : '#E5F3FB',
                }}
              >
                <Stack paddingY="10px" borderBottom="1px solid #D8D8D8">
                  <Typography fontSize="12px" fontWeight="bold" lineHeight="1.6" color="#333333">
                    {list.notificationType.toUpperCase()}
                  </Typography>
                </Stack>
                <Stack paddingY="10px" direction="row" width="100%" gap="10px">
                  <Box
                    component="img"
                    src="/assets/logo/logo-binusuniv.svg"
                    sx={layoutPrivateStyle.notificationListCardAvatar}
                  />
                  <Stack gap="0.5rem">
                    <Typography component="div" sx={layoutPrivateStyle.notificationListCardMessage}>
                      <Box fontWeight="normal" display="inline">
                        {`${list.notificationContent} `}
                      </Box>{' '}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            ))}
          </Stack>
        ) : (
          <Stack sx={layoutPrivateStyle.notificationListContainerNull}>
            <Box
              component="img"
              src="/assets/image/ilustrasi-no-upcoming-class.svg"
              width="310px"
            />
            <Stack>
              <Typography
                sx={layoutPrivateStyle.notificationListEmpty}
              >{`You don't have any notifications`}</Typography>
              <Typography fontSize="14px" textAlign="center">
                Please check back later.
              </Typography>
            </Stack>
          </Stack>
        )}
      </Stack>
    </Drawer>
  );
}
